import { render } from "./TermsConditionsContent.vue?vue&type=template&id=212f3d6f&scoped=true"
import script from "./TermsConditionsContent.vue?vue&type=script&lang=js"
export * from "./TermsConditionsContent.vue?vue&type=script&lang=js"

import "./TermsConditionsContent.vue?vue&type=style&index=0&id=212f3d6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212f3d6f"]])

export default __exports__